import { useState } from "react";
import { Button } from "react-bootstrap";
import OptionsDialog from "./OptionsDialog";
import { useDispatch, useSelector } from "react-redux";
import {
  SelectAddNew,
  setEditMode,
  setAddNew,
  setLocaleID,
  SelectTranslationForm,
  resetTranslationForm,
  updateTranslationForm,
  clearTranslationForm
} from "../../../../features/translations/translationsSlice";

const SettingsCard = () => {
  const dispatch = useDispatch();
  const addNew = useSelector(SelectAddNew);
  const formData = useSelector(SelectTranslationForm);
  
  const [optionsDialog, setOptionsDialog] = useState(false);

  function handlePopulate(value) {
    if (value === 0) {
      // reset the form field values to the original state
      dispatch(resetTranslationForm());
    }

    if (value === 1) {
      // set form field values to empty string
      const updatedFormData = formData.map((item) => ({ ...item, value: "" }));
      dispatch(updateTranslationForm(updatedFormData));
    }
    if (value === 2) {
      // set all the form field values to default values
      const updatedFormData = formData.map((item) => ({
        ...item,
        value: item.default_value,
      }));

      dispatch(updateTranslationForm(updatedFormData));
    }
    if (value === 3) {
      // for future implementation using an asyc function fetching data from an translation provider
      console.log("lets translate over API");
    }
  }

  const handleCancelAction = (value) => {
    dispatch(setEditMode(false));
    dispatch(setAddNew(false));
    dispatch(setLocaleID(-1));
    dispatch(clearTranslationForm())
  };

  return (
    <>
      <div className="col-xl-6 col-lg-6 py-4">
        <div className="card">
          <div className="card-header">
            <h4 className="card-title">Settings</h4>
          </div>
          <div className="card-body">
            <div className="basic-form">
              <div className="form-group">
                <Button
                  type="submit"
                  form="myform"
                  className="me-2"
                  variant="success"
                >
                  {addNew ? "Save New" : "Save Changes"}
                </Button>
                <Button
                  className="me-2"
                  variant="warning"
                  onClick={handleCancelAction}
                >
                  Cancel
                </Button>
                <OptionsDialog
                  optionsDialog={optionsDialog}
                  setOptionsDialog={setOptionsDialog}
                  handlePopulate={handlePopulate}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SettingsCard;
